export default __webpack_public_path__ + "static/media/woocommerce.42278612.svg";